export const suggestionsDefault = {
  selected: {},
  suggestionsData: {},
  suggestionsListOpened: true,
};

export const defaultInputData = {
  option: '',
  provider: '',
  address: '',
};

export const LOCATION_ALREADY_EXIST =
  'The location you are trying to add already exists in the database. Please verify the details and add the provider location again.';
export const IMAGE_UPLOAD_ERROR =
  'Please try uploading single images one after the other. If the issue still persists, please convert the image to .JPEG or .JPG and try uploading the image again.';

export const SELECT_ALL = 'Select All';

export const MAX_ALLOWED_LOCATION_IMAGES = 10;
